// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__3ttOm","alert":"SettungsInbox_alert__2GQNt"};